<template>
<v-app>
    <v-app-bar
        app
        color="#F24653"
        dark
        dense
    >
        <v-toolbar-title>
            <slot name="title"></slot>
        </v-toolbar-title>
    </v-app-bar>
    <v-main>
        <v-container>
            <div
                style="text-align: center"
            >
                <img 
                    src="@/assets/redchirp-logo-square-center.png" 
                    class="img"
                    style="width: 225px; margin-top: 15px; margin-bottom: 15px;"
                    
                />
            </div>

            <h3
                style="margin-bottom: 15px"
            >
                We Have Updated Our Agreements for 2026
            </h3>

            <p>
                Before we go into the nitty gritty, rest assured that no action is needed from you and these changes shouldn’t affect how you use RedChirp.  This change does not affect what you pay for RedChirp.
            </p>

            <p>
                <b>Why are we updating our agreements?</b>
            </p>

            <p>
                It's been more than two years since we last updated our terms and conditions and a lot has changed since then—with more to come!
            </p>

            <p>
                These modifications could be summarized as follows:
            </p>

            <ul class="my_list">
                <li>Included new terms regarding new awesome functionalities that we are planning to offer</li>
                <li>We have made miscellaneous improvements to the grammar, fixed typos and the like</li>
                <li>We have updated the hyper links between our various agreements to keep them up to date</li>
                <li>We have added language that should better allow RedChirp staff to take certain limited actions within your RedChirp account as directed by you</li>
                <li>We have added language to clarify the "cancel at any time" nature of RedChirp</li>
                <li>Made changes to the Organization’s Obligations, arbitration agreement, class action waiver, and your compliance requirements</li>
                <li>Better aligned the terms used in the Organization Subscription Agreement with the terms used in the Authorized User Agreement, Authorized User Terms of Use and Authorized User Privacy Policy</li>
                <li>Updated the Authorized User Privacy Policy to address new and emerging data processing and privacy concerns</li>
                <li>Clarified the mechanisms under which Authorized Users of RedChirp can opt out of RedChirp messaging</li>
                <li>Clarified what to do if you believe that a child has submitted personal information to RedChirp</li>
            </ul>

            <p>
                To read the revised agreements, use the hyperlinks below:
            </p>

            <ul class="my_list">
                <li
                    v-for="(item, index) in agreements"
                    :key="'revsised'+index"
                >
                    <a
                        :href="item.url"
                        target="_blank"
                    >
                        {{item.label}}
                    </a>
                </li>
            </ul>

            <p>
                To read the prior (form) version of the agreements, use the hyperlinks below:
            </p>

            <ul class="my_list">
                <li
                    v-for="(item, index) in agreements"
                    :key="'revsised'+index"
                >
                    <a
                        :href="item.original_url"
                        target="_blank"
                    >
                        Prior Version: {{item.label}}
                    </a>
                </li>
            </ul>

            <p>
                To see the changes that have been made to each agreement, view the redlines provided using the hyperlinks below:
            </p>

            <ul class="my_list">
                <li
                    v-for="(item, index) in agreements"
                    :key="'revsised'+index"
                >
                    <a
                        :href="item.redlines_url"
                        target="_blank"
                    >
                        Redlines: {{item.label}}
                    </a>
                </li>
            </ul>

            <p>
                <b>Does this impact how I use RedChirp?</b>
            </p>

            <p>
                Considering that we are changing the terms to make them clearer, improve compliance and enhance our security privacy standards, you will be able to keep seamlessly using the services without interruption.
            </p>

            <p>
                <b>Do I need to do anything at all?</b>
            </p>

            <p>
                If you're happy with the changes, you don't need to do anything. The changes will automatically apply on Feb 15th, 2026.  
            </p>

            <p>
                You can choose to sign the revised agreements within the RedChirp software at any time, in which case they will become effective upon your acceptance of the new agreements.
            </p>

            <p>
                If you're not comfortable with the new wording, you can always contact us to negotiate specific terms and conditions for your account through an enterprise plan or cancel your account before the date mentioned above—but we'd be sad to see you go.  
            </p>

            <p>
                Kind regards,
            </p>

            <p>
                The RedChirp Team
            </p>
        </v-container>
    </v-main>
</v-app>
</template>

<script>

export default {
    data() {
        return {
            agreements: [
                {
                    url: 'https://files.redchirp.com/2026-01-01-red-chirp-authorized-user-agreement.pdf',
                    original_url: 'https://files.redchirp.com/cytcuebxzfwfuvudytawwbbarxaztdcv.pdf',
                    label: 'RedChirp Authorized User Agreement',
                    redlines_url: 'https://files.redchirp.com/2026-01-01-redline-authorized-user-agreement.pdf'
                },

                {
                    url: 'https://files.redchirp.com/2026-01-01-red-chirp-authorized-user-privacy-policy.pdf',
                    original_url: 'https://files.redchirp.com/swduwdqyfsvuuwsxzsruaxqfaydxtudt.pdf',
                    label: 'RedChirp Authorized User Privacy Policy',
                    redlines_url: 'https://files.redchirp.com/2026-01-01-redline-authorized-user-privacy-policy.pdf'
                },

                {
                    url: 'https://files.redchirp.com/2026-01-01-red-chirp-authorized-user-terms-of-use.pdf',
                    original_url: 'https://files.redchirp.com/errewdxxfxzfuyffywtyfxrcfecrducv.pdf',
                    label: 'RedChirp Authorized User Terms of Use',
                    redlines_url: 'https://files.redchirp.com/2026-01-01-redline-authorized-user-terms-of-use.pdf'
                },

                {
                    url: 'https://files.redchirp.com/2026-01-01-red-chirp-organization-subscription-agreement.pdf',
                    original_url: 'https://files.redchirp.com/zyxeryqxebtrutdrbvwcbwwuxbfwruur.pdf',
                    label: 'RedChirp Organization Subscription Agreement',
                    redlines_url: 'https://files.redchirp.com/2026-01-01-redline-organization-subscription-agreement.pdf'
                },
            ],
        }
    },

    methods: {
    },
}

</script>

<style lang="scss" scoped>
.my_list {
    margin-bottom: 15px;
}
.my_list li {
    margin-top: 15px;
}
</style>